import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { Button, Tooltip } from '@material-ui/core'
import { DownloadIcon } from '../../../icons'
import { getLang } from '../../app/selectors/lang'
import { getRegionFromLocationId } from '../../app/selectors'
import useActiveLocationData from '../../location/hooks/useActiveLocationData'
import { getStateAbbr } from '../../../../shared/utils/states'

/**
 * Button that downloads a report for the active location when pressed
 */
const DownloadButton = ({ ...props }) => {
  const location = useActiveLocationData()
  const region = location && getRegionFromLocationId(location.id)
  const state = location && getStateAbbr(location.id)
  const hasDownload = region === 'districts' || region === 'states'
  const url = location && `https://edopportunity.org/reports/recovery/${state}/report_${state}_${location.id}_${kebabCase(location.name)}.pdf`
  // https://seda-pdf.s3.us-east-1.amazonaws.com/reports/AK/report_AK_0200005_kashunamiut-school-district.pdf

  return (
    <Tooltip
      title={!hasDownload ? getLang('LOCATION_REPORT_BUTTON_DISABLED') : ''}
      placement="top"
      arrow
    >
      <span>
        <Button
          href={url}
          target="_blank"
          download
          {...props}
        >
          <DownloadIcon />
          {getLang('LOCATION_REPORT_BUTTON')}
        </Button>
      </span>
    </Tooltip>
  )
}

export default DownloadButton
